import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope, FaBars, FaTimes, FaChevronDown } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import logo from "../assets/logo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const navLinks = [
    { name: 'Home', path: '/' },
    { 
      name: 'Services', 
      path: '/services'
    },
    { name: 'Process', path: '/process' },
    { name: 'Requirements', path: '/requirements' },
    { name: 'Countries', path: '/countries' },
    { name: 'About', path: '/about' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
      {/* Top Bar */}
      <div className="bg-primary-900 text-white py-2">
        <div className="container-padding flex flex-col sm:flex-row justify-between items-center">
          <div className="flex items-center space-x-4 mb-2 sm:mb-0">
            <div className="flex items-center">
              <FaPhoneAlt className="mr-2" />
              <span>0313-5993810</span>
            </div>
            <div className="flex items-center">
              <FaEnvelope className="mr-2" />
              <span>nextstepconsultant91@gmail.com</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navbar */}
      <nav className="sticky top-0 z-50 bg-white shadow-lg">
        <div className="container-padding">
          <div className="flex justify-between items-center h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img src={logo} alt="Visa Agency Logo" className="h-12 w-[150px] mr-2" />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center space-x-8">
              {navLinks.map((link) => (
                <div key={link.name} className="relative group">
                  {link.dropdown ? (
                    <>
                      <button
                        className="flex items-center text-gray-700 hover:text-primary-600 font-medium transition"
                        onMouseEnter={() => setDropdownOpen(link.name)}
                        onMouseLeave={() => setDropdownOpen(null)}
                      >
                        {link.name}
                        <FaChevronDown className="ml-1 text-xs" />
                      </button>
                      <AnimatePresence>
                        {dropdownOpen === link.name && (
                          <motion.div
                            initial={{ opacity: 0, y: 10 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 10 }}
                            className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl border py-2 z-50"
                            onMouseEnter={() => setDropdownOpen(link.name)}
                            onMouseLeave={() => setDropdownOpen(null)}
                          >
                            {link.dropdown.map((item) => (
                              <Link
                                key={item.name}
                                to={item.path}
                                className="block px-4 py-2 text-gray-700 hover:bg-primary-50 hover:text-primary-600 transition"
                              >
                                {item.name}
                              </Link>
                            ))}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </>
                  ) : (
                    <Link
                      to={link.path}
                      className="text-gray-700 hover:text-primary-600 font-medium transition"
                    >
                      {link.name}
                    </Link>
                  )}
                </div>
              ))}
              <Link to="/contact" className="btn-primary">
                Free Consultation
              </Link>
            </div>

            {/* Mobile menu button */}
            <button
              className="lg:hidden text-gray-700"
              onClick={() => setIsOpen(!isOpen)}
            >
              {isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
            </button>
          </div>

          {/* Mobile Navigation */}
          <AnimatePresence>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                className="lg:hidden overflow-hidden"
              >
                <div className="py-4 space-y-2">
                  {navLinks.map((link) => (
                    <div key={link.name}>
                      {link.dropdown ? (
                        <div className="space-y-1">
                          <div className="font-medium text-gray-700 px-2 py-2">
                            {link.name}
                          </div>
                          {link.dropdown.map((item) => (
                            <Link
                              key={item.name}
                              to={item.path}
                              className="block px-4 py-2 text-gray-600 hover:bg-primary-50 rounded transition"
                              onClick={() => setIsOpen(false)}
                            >
                              {item.name}
                            </Link>
                          ))}
                        </div>
                      ) : (
                        <Link
                          to={link.path}
                          className="block px-2 py-3 text-gray-700 hover:text-primary-600 font-medium transition"
                          onClick={() => setIsOpen(false)}
                        >
                          {link.name}
                        </Link>
                      )}
                    </div>
                  ))}
                  <Link
                    to="/contact"
                    className="btn-primary block text-center mt-4"
                    onClick={() => setIsOpen(false)}
                  >
                    Free Consultation
                  </Link>
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </nav>
    </>
  );
};

export default Navbar;